export class CycleIotDataReader {
  private combinedBuffer: string;
  private isWaitForChunk: boolean;
  private streamIotData: Record<string, any[]>;
  private updateCallback?: (data: Record<string, any[]>) => void;

  private readonly decoder: TextDecoder;
  private readonly reader: ReadableStreamDefaultReader;
  private readonly messageEndIndicator: string;
  private readonly twoMessagesIndicator: string;
  constructor(reader: ReadableStreamDefaultReader, updateCallback?: (data: Record<string, any[]>) => void) {
    this.reader = reader;
    this.decoder = new TextDecoder();
    this.messageEndIndicator = ':true}]';
    this.twoMessagesIndicator = '][';
    this.combinedBuffer = '';
    this.streamIotData = {};
    this.isWaitForChunk = false;

    if (updateCallback) {
      this.updateCallback = updateCallback;
    }
  }

  async getIotData(): Promise<Record<string, any[]>> {
    while (true) {
      const { value, done } = await this.reader.read();

      if (done) {
        break;
      }

      const buffer = this.decoder.decode(value, { stream: true }).trim();

      try {
        this.parseBuffer(buffer);
        this.parseCombinedBuffer();
      } catch (error) {
        console.error('Get IoT data stream error: ', error);
        this.reader.cancel();

        break;
      }
    }

    return this.streamIotData;
  }

  private parseBuffer(buffer: string) {
    if (this.isWaitForChunk) {
      this.markForWaitChunk(buffer);
    }

    if (!this.isWaitForChunk) {
      try {
        this.updateDataFromBuffer(buffer);
      } catch (error) {
        this.markForWaitChunk(buffer);
      }
    }
  }

  private parseCombinedBuffer() {
    const isHasEnd = this.combinedBuffer.endsWith(this.messageEndIndicator);
    if (isHasEnd) {
      this.parseMessage(this.combinedBuffer);
      this.cleanWaitingChunk();
    }
  }

  private parseMessage(message: string) {
    const isHasTwoMessages = message.includes(this.twoMessagesIndicator);

    if (!isHasTwoMessages) {
      this.updateDataFromBuffer(message);
    } else {
      const index = message.indexOf(this.twoMessagesIndicator);
      const messages = [message.slice(0, index + 1), message.slice(index + 1)];
      for (const mes of messages) {
        this.parseMessage(mes);
      }
    }
  }

  private updateDataFromBuffer(buffer: string) {
    const data = JSON.parse(buffer)[0];
    Object.keys(data).forEach((key) => {
      if (this.streamIotData[key]) {
        this.streamIotData[key].push(...data[key]);
      } else {
        this.streamIotData[key] = data[key];
      }
    });

    if (this.updateCallback) {
      this.updateCallback({ ...data });
    }
  }

  private markForWaitChunk(currentChunk: string) {
    this.isWaitForChunk = true;
    this.combinedBuffer += currentChunk;
  }

  private cleanWaitingChunk() {
    this.combinedBuffer = '';
    this.isWaitForChunk = false;
  }
}
